<template>
  <v-card>
    <v-card-title>
      Patient Object Dump
      - Index: {{ $store.getters['patients/getIndexById']($route.query.id), }}
      <v-spacer></v-spacer>
      <btn
        label="Reset Patient"
        color="secondary"
        :icon="icons.mdiUndoVariant"
        @click="resetPatient"
      ></btn>
    </v-card-title>
    <v-card-text>
      <textarea
        ref="dumpPatient"
        v-model="contentPatient"
        style="height:700px;border:thin solid #777;border-radius:5px;"
        class="col-sm-12"
      ></textarea>
    </v-card-text>
    <v-card-actions>
      <btn
        label="Back"
        color="secondary"
        :icon="icons.mdiArrowLeftCircle"
        @click="$store.dispatch('route/back')"
      ></btn>
      <v-spacer></v-spacer>
      <btn
        label="Update Patient"
        :icon="icons.mdiContentSave"
        color="error"
        @click="updatePatient"
      ></btn>
      <v-spacer></v-spacer>
      <btn
        label="Clip Patient"
        :icon="icons.mdiContentCopy"
        @click="copyPatientToClipboard"
      ></btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mdiArrowLeftCircle, mdiContentCopy, mdiContentSave, mdiUndoVariant,
} from '@mdi/js'

export default {
  data() {
    return {
      patient: this.$store.getters['patients/getById'](this.$route.query.id),
      contentPatient: null,
      icons: {
        mdiArrowLeftCircle, mdiContentCopy, mdiContentSave, mdiUndoVariant,
      },
    }
  },
  mounted() {
    this.contentPatient = JSON.stringify(this.patient, null, 2)
  },
  methods: {
    copyPatientToClipboard() {
      this.$refs.dumpPatient.select()
      document.execCommand('copy')
    },
    updatePatient() {
      let patient = null
      try {
        patient = JSON.parse(this.contentPatient)
      } catch (e) {
        this.$store.dispatch('notify', { value: e, color: 'error' })
      }
      if (patient) {
        this.$root.confirm({
          title: 'Update Patient?',
          titleIconColor: 'error',
          body: 'Are you sure you wish to update this patient?',
          confirm: 'Update',
          confirmColor: 'error',
        }).then(result => {
          if (result === true) {
            this.$store.commit('patients/updatePatientSync', patient)
            this.$store.dispatch('notify', { value: `Patient ${patient.id} updated.`, color: 'success' })
          }
        })
      }
    },
    resetPatient() {
      this.patient = this.$store.getters['patients/getById'](this.$route.query.id)
      this.contentPatient = JSON.stringify(this.patient, null, 2)
      this.$store.dispatch('notify', { value: `Patient ${this.patient.id} reset.`, color: 'success' })
    },
  },
}
</script>
